import type { AccountData as Account } from '~publish/contexts/AccountContext'
import { isFreeUser, isTrialUser } from '~publish/helpers/user'

import {
  isPaymentMethodBank,
  isRevenueCatBillingGateway,
} from '../../Billing/utils/planUtils'

export function shouldShowAddRemoveChannels(account: Account | null): boolean {
  if (!account) {
    return false
  }

  // 1. Legacy or trial users should not see the button
  const isOneBufferOrganization =
    account?.currentOrganization?.isOneBufferOrganization
  const isOnTrial = isTrialUser(account)
  if (!isOneBufferOrganization || isOnTrial) {
    return false
  }

  // 2. Free, mobile, or bank payment users should not see the button
  const isFree = isFreeUser(account)
  const isMobileBilling = isRevenueCatBillingGateway(account)
  const isBankPayment = isPaymentMethodBank(account)
  if (isFree || isMobileBilling || isBankPayment) {
    return false
  }

  return true
}
